/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

    export class SingleUpload extends BaseField {
        protected opts: UploadOptions;

        constructor (element: string | JQuery, opts: ObjectHash = {}) {
            super(element, opts);

            let self = this;

            this.element.parents('.btn-file').find(':file').on('fileselect', function(event, numFiles, label) {
                let input = $(this).parents('.input-group').find(':text');

                if (input.length) {
                    input.val(label);
                }
            });
        }

        public getFile() {
            return this.element.prop('files')[0];
        }

        public getValue() {
            let thumbElement = this.getThumbnailElement();

            if (thumbElement) {
                let src = thumbElement.getAttribute("src");

                if (src.length > 42) {
                    return src;
                }

                return null;
            }

            return this.element.prop('files')[0];
        }

        public reset() {
            super.reset();

            // @ts-ignore
            this.element[0].value = '';

            this.getThumbnailElement().src = '';

        }

        private getThumbnailElement(): HTMLImageElement {
            return document.getElementById(this.name + '-thumbnail') as HTMLImageElement
        }
    }


    interface UploadOptions extends FieldOptions {

    }

}
